import { TableView, SelectionDirection } from 'owa-mail-list-store';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import rangeSelectRowInternal from './rangeSelectRowInternal';
import singleSelectRowInternal from './singleSelectRowInternal';
import { trace } from 'owa-trace';

/**
 * Select row in the direction given
 * @param tableView where the operation is being performed
 * @param selectionDirection direction of the selection
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export default function selectRowInDirectionInternal(
    tableView: TableView,
    selectionDirection: SelectionDirection,
    mailListItemSelectionSource: MailListItemSelectionSource
) {
    const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
    if (selectedRowKeys.length > 0 || tableView.focusedRowKey) {
        selectRowInDirectionHelper(
            tableView,
            selectionDirection,
            tableView.selectionAnchorRowKey || tableView.focusedRowKey,
            mailListItemSelectionSource
        );
    } else if (tableView.rowKeys.length > 0) {
        // Select the first item when there is no selection
        singleSelectRowInternal(
            tableView,
            tableView.rowKeys[0],
            true /* isUserNavigation */,
            mailListItemSelectionSource
        );
    }
}

function selectRowInDirectionHelper(
    tableView: TableView,
    selectionDirection: SelectionDirection,
    rowKey: string,
    mailListItemSelectionSource: MailListItemSelectionSource,
    isRangeSelection?: boolean
): void {
    const tableRowKeys = tableView.rowKeys;
    let selectedIndex = tableRowKeys.indexOf(rowKey);

    if (selectedIndex < 0) {
        trace.error('Invalid selectedIndex');
        return;
    } else if (
        (selectedIndex == 0 && selectionDirection == SelectionDirection.Previous) ||
        (selectedIndex == tableRowKeys.length - 1 && selectionDirection == SelectionDirection.Next)
    ) {
        singleSelectRowInternal(
            tableView,
            tableRowKeys[selectedIndex],
            true /* isUserNavigation */,
            mailListItemSelectionSource
        );
        return;
    }

    switch (selectionDirection) {
        case SelectionDirection.Next:
            selectedIndex++;
            break;
        case SelectionDirection.Previous:
            selectedIndex--;
            break;
    }

    const tableRowKey = tableRowKeys[selectedIndex];

    if (isRangeSelection) {
        rangeSelectRowInternal(tableView, tableRowKey, mailListItemSelectionSource);
    } else {
        singleSelectRowInternal(
            tableView,
            tableRowKey,
            true /* isUserNavigation */,
            mailListItemSelectionSource
        );
    }
}
